var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":_vm.$t('components.ReviewsByRating.Title'),"loading":_vm.loading,"report-mode":_vm.reportMode}},[_c('HorizontalBarChart',{attrs:{"stats":_vm.stats,"styles":_vm.styles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }